import { useMutation } from "@tanstack/react-query";
import request from "../../../../Api/request";

export const useDecisionLogActions = ({
	projectId,
	decisionFormContext,
	setIsCreateModalOpen,
	refetchDecisions,
	setIsEditProjectModalOpen,
	refetchProject,
}) => {
	const { resetForm } = decisionFormContext;

	const { mutate: createDecision, isFetching: isCreatingDecision } = useMutation({
		mutationFn: async (decision) => {
			const result = await request({
				url: "/api/decision-log/decisions",
				method: "POST",
				data: {
					projectId,
					decision,
				},
			});

			refetchDecisions();
			setIsCreateModalOpen(false);
			resetForm();

			return result;
		},
	});

	const { mutate: updateDecision, isFetching: isUpdatingDecision } = useMutation({
		mutationFn: (data) => {
			return request({
				url: `/api/decision-log/decisions/${data.decisionId}`,
				method: "PUT",
				data: {
					decision: data.newValue,
				},
			});
		},
	});

	const { mutate: deleteDecisions, isFetching: isDeletingDecisions } = useMutation({
		mutationFn: (decisionIds) => {
			return request({
				url: "/api/decision-log/decisions",
				method: "DELETE",
				data: {
					decisionIds,
				},
			});
		},
		onSuccess: () => {
			refetchDecisions();
		},
	});

	const { mutate: updateProject } = useMutation({
		mutationFn: async ({ name, description }) => {
			setIsEditProjectModalOpen(false);

			const result = await request({
				url: `/api/decision-log/projects/${projectId}`,
				method: "PUT",
				data: {
					name,
					description,
				},
			});

			refetchProject();

			return result;
		},
	});

	return {
		createDecision,
		updateDecision,
		deleteDecisions,
		updateProject,
		isCreatingDecision,
		isUpdatingDecision,
		isDeletingDecisions,
	};
};
